module.exports = __webpack_public_path__ + "img/editlist.694dd3e1.svg";